import React, { useEffect, useMemo, useState } from "react";
import ConfigHeaderNav from "../../components/HeadersNav/ConfigHeaderNav";
import { Autocomplete, Box, Card, CircularProgress, Grid, MenuItem, TextField, Typography } from "@mui/material";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import MyTable from "../../components/Schedule/MyTable";
import PaginationComponent from "../../components/Pagination/Pagination";
import EditConfig from "../../components/System/EditConfig";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { setSelectOptionsListDDL } from "../../store/ddlReducer";
import { useSelector, useDispatch } from "react-redux";
import FormSelectOption from "../../components/System/FormSelectOption";
import SystemHeaderNav from "../../components/HeadersNav/SystemHeaderNav";
import Deleteconfirmation from "../../components/DeleteModal/DeleteModal";
import { useSnackbar } from "notistack";
import { toast } from 'react-toastify';

export default function SelectOption() {
    const dispatch = useDispatch();
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [rows, setRows] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editItem, setEditItem] = useState();
    const [deleteItemRow, setDeleteItemRow] = useState();
    const [openModalDelete, setOpenModalDelete] = useState(false);

    let SelectOptionsListDDL = useSelector((state) => { return state.ddlReducer.SelectOptionsListDDL; });
    let columns = [
        {
            field: 'SO_Code',
            headerName: 'Code',
            sortable: false,
            flex: 1, minWidth: 200,
            filterable: false,
            // renderCell: (params) => (selectedShift == undefined || (selectedShift && selectedShift == params.row.Shift_Code)) && <CheckboxRenderer setRowSelectionModel={setRowSelectionModel} rowSelectionModel={rowSelectionModel} setSelectedShift={setSelectedShift} selectedPatch={selectedPatch} setSelectedPatch={setSelectedPatch} {...params} />,
        },
        {
            field: 'SO_Value',
            headerName: 'Value',
            sortable: false,
            flex: 1, minWidth: 200,
            filterable: false,
        },
        {
            field: 'SO_Desc',
            headerName: 'Description',
            sortable: false,
            flex: 1, minWidth: 200,
            filterable: false,
        },
        {
            field: 'SO_Condition',
            headerName: 'Condition',
            sortable: false,
            flex: 1, minWidth: 200,
            filterable: false,
        },
        {
            field: 'SO_Sort',
            headerName: 'Sort',
            sortable: false,
            flex: 1, minWidth: 200,
            filterable: false,
        },
        {
            field: 'Action',
            headerName: 'Action',
            sortable: false,
            flex: 1, minWidth: 200,
            filterable: false,
            renderCell: (params) => {
                return (
                    // <div className="d-flex justify-content-center ">
                    <div
                        style={{ width: "50%" }}
                        className="d-flex justify-content-between action-btn-color"
                    >

                        <button
                            className="btn bg-transparent text-primary  px-1"
                            onClick={() => editRow(params.row)}
                        >
                            <EditOutlinedIcon />
                        </button>
                        <button
                            className="btn bg-transparent text-secondary px-1"
                            onClick={() => copyRow(params.row)}
                        >
                            <ContentCopyOutlinedIcon />
                        </button>
                        <button
                            className="btn bg-transparent text-danger px-1"
                            onClick={() => deleteRow(params.row)}
                        >
                            <DeleteOutlineOutlinedIcon />
                        </button>

                    </div>
                    // </div>
                )
            },
        },
    ];

    let loadData = (searchText = '', page = 1) => {
        setLoading(true)
        ApiService.get('/getAllSelectOption', { page: page, search: searchText }, 'getAllSelectOption')
            .then(({ data }) => {
                setLoading(false)
                // console.log('data',data.data);
                setRows(data.data)
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    let editRow = (row) => {
        setEditMode('edit');
        setEditItem(row)
    }

    let copyRow = (row) => {
        setEditMode('copy');
        setEditItem(row)
    }

    let createRow = () => {
        setEditMode('create');
        setEditItem()
    }
    let deleteRow = (row) => {
        setDeleteItemRow(row)
        setOpenModalDelete(true)
    }

    let CloseDeleteMode = () => {
        setOpenModalDelete(false);
        setDeleteItemRow()
    }
    let deleteItem = () => {
        ApiService.delete('/deleteSelectOption', { SO_Code: deleteItemRow.SO_Code, SO_Value: deleteItemRow.SO_Value }
        ).then((data) => {
            loadData(search, 1)
            toast.success(data.message)
            // enqueueSnackbar("deleted successfully", { variant: "success" });
        }).catch(({ data }) => {
            toast.error(data.message)
            // enqueueSnackbar(data.message, { variant: "error" });
        })
        CloseDeleteMode()
    }

    useEffect(() => {
        loadData();
        ApiService.get("/getSelectOptionListDDL").then(({ data }) => {
            dispatch(setSelectOptionsListDDL(data));
        });
    }, [])

    const menuArray = SelectOptionsListDDL.map((i) => ({
        value: i,
        label: i
    }));

    let FilterData = () => {
        loadData(search, 1);
    }

    const PageChanged = (e, page) => {
        loadData(search, page);
    };

    let CloseEditMode = () => {
        setEditMode(false);
        setEditItem()
    }

    let handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            // console.log('Enter key pressed');
            // Perform the action you want when Enter key is pressed
            FilterData()
            // console.log('SelectOptionsListDDL', SelectOptionsListDDL);
        }
    }

    return (
        <>
            {/* <ConfigHeaderNav /> */}
            <SystemHeaderNav />
            <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
                <Typography variant="h5">System Option</Typography>
                <Grid container
                    spacing={2}
                    columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                    className="my-2">

                    {!editMode && <Grid item xs={4} md={8}>
                        <div className="row">
                            <div className="col-12 col-md-5 col-lg-3">

                                <Autocomplete
                                    className="mx-0 mx-md-2 my-2 my-md-0 w-100"
                                    options={menuArray}
                                    onChange={(e, newValue) => setSearch(newValue?.value || '')}
                                    onKeyDown={handleKeyPress}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Code"
                                            placeholder="Search Code"
                                            color="secondary"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: "48px",
                                                    fontSize: "1rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                },
                                                "& .MuiFormLabel-root": {
                                                    marginTop: "4px"
                                                },
                                                "& .MuiInputLabel-shrink": {
                                                    marginTop: "0px"
                                                }
                                            }} />
                                    )}
                                />

                                {/* <TextField
                                    select
                                    className="mx-0 mx-md-2 my-2 my-md-0 w-100"
                                    color={"secondary"}
                                    placeholder="Search Code"
                                    label="Search Code"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyDown={handleKeyPress}
                                    InputProps={{
                                        sx: {
                                            height: '48px',
                                            display: "flex",
                                        }
                                    }}>

                                    {menuArray.map((i) => (
                                        <MenuItem value={i.value} key={i.value}>
                                            {i.label}
                                        </MenuItem>
                                    ))}

                                </TextField> */}
                            </div>

                            <div className="col-12 col-md-5 col-lg-3">
                                <Autocomplete
                                    className="mx-0 mx-md-2 my-2 my-md-0 w-100"
                                    disablePortal
                                    options={SelectOptionsListDDL.map((item) => {
                                        return {
                                            label: item,
                                            value: item,
                                        };
                                    })}
                                    onChange={(e, value) => {
                                        setSearch(value.value)
                                        loadData(value.value, 1);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            color="secondary"
                                            {...params}
                                            label="All"
                                            InputProps={{
                                                sx: {
                                                    height: '48px',
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </div>

                            <div className="col-12 col-md-2 col-lg-1 d-flex ">
                                <ButtonTheme className="w-100 my-2 my-md-0" color={"primary"} onClick={FilterData}>Filter</ButtonTheme>
                            </div>

                            <div className="col-12 col-md-2 col-lg-1 d-flex offset-lg-4 ">
                                <ButtonTheme className="w-100 my-2 my-md-0" color={"primary"} onClick={createRow} disabled={loading}>Create</ButtonTheme>
                            </div>

                        </div>
                    </Grid>}

                    <Grid item xs={4} md={8}>
                        {!loading && !editMode && <div>
                            <MyTable rows={rows.data} columns={columns} checkboxSelection={false} hideFooter={true} />
                            <br />
                            <PaginationComponent
                                results={rows}
                                pageChanged={PageChanged}
                            />
                        </div>}

                        {
                            loading && <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                                <CircularProgress />
                            </Box>
                        }

                        {!loading && editMode && <>
                            <button onClick={CloseEditMode} className="btn bg-transparent border-0 my-2">
                                <ArrowBackIosIcon /> Back
                            </button>

                            <FormSelectOption editMode={editMode} editItem={editItem} CloseEditMode={CloseEditMode} loadData={loadData} />
                        </>}

                        <Deleteconfirmation openModal={openModalDelete} acceptFunction={deleteItem} rejectFunction={CloseDeleteMode} />
                    </Grid>
                </Grid>
            </Card>
        </>
    )
}
